import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { useFormContext } from 'react-hook-form'

import { Card, CardContent } from '@/components/ui/card'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Checkbox } from '@/components/ui/checkbox'
import { PromotionFormData } from './promotion-form'

export const PromotionSettingsCard = () => {
    const { t } = useTranslation('stores')
    const { watch, setValue: rawSetValue, formState: { errors } } = useFormContext<PromotionFormData>()
    const setValue: typeof rawSetValue = (name, value, options) =>
        rawSetValue(name, value, { shouldDirty: true, ...options })

    const name = watch('name')
    const automatic = watch('automatic')

    return (
        <Card className="py-4">
            <CardContent>
                <div className="space-y-4">
                    <div>
                        <Label htmlFor="name" className="text-xs">
                            {t('promotion.fields.name')}
                        </Label>
                        <Input
                            id="name"
                            value={name}
                            onChange={(e) =>
                                setValue('name', e.target.value, { shouldValidate: !!errors.name })
                            }
                            className="h-8"
                            error={!!errors.name}
                            aria-invalid={errors.name ? true : undefined}
                            aria-describedby={errors.name ? 'name-error' : undefined}
                            required
                        />
                        {errors.name && (
                            <p id="name-error" className="mt-1 text-xs text-destructive">
                                {t('promotion.validation.nameRequired')}
                            </p>
                        )}
                    </div>
                    <div className="flex items-center gap-2">
                        <Checkbox
                            id="automatic"
                            checked={automatic || false}
                            onCheckedChange={(checked) => setValue('automatic', checked === true)}
                        />
                        <Label htmlFor="automatic" className="text-xs">
                            {t('promotion.fields.automaticApply')}
                        </Label>
                    </div>
                </div>
            </CardContent>
        </Card>
    )
}

